// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"f0ffb292","787":"5a3711b5"}[chunkId] + ".chunk.js";
};